module.exports = __webpack_public_path__ + "img/logo.8bb4a242.png";